import React, { useState, useEffect, useRef } from "react";
import {
  View,
  TouchableOpacity,
  useWindowDimensions,
  Text,
} from "react-native";
import Logo from "../assets/Logo";
import { FaUser } from "react-icons/fa";
import SimpleButton from "./SimpleButton";
import { LogoutUser } from "../redux/actions/auth";
import { connect, useSelector } from "react-redux";
import { useQueryClient } from "react-query";
import { Link } from "react-router-dom";
import { Button, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { AccountCircle, LogoutSharp } from "@mui/icons-material";

const Header = (props) => {
  // const [loginDropdown, setLoginDropdown] = useState(false);
  const [tabSelected, setTabSelected] = useState("home");
  const ref = useRef();
  const queryClient = useQueryClient();

  const { width } = useWindowDimensions();

  const { isAdmin, analystName, accountRole, tabsAccessible } = useSelector(
    (state) => ({
      isAdmin: state.auth.isAdmin,
      analystName: state.auth.analystName,
      accountRole: state.auth.accountRole,
      tabsAccessible: state.auth.tabsAccessible,
    })
  );

  const [anchorEl, setAnchorEl] = useState();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isMobile = width < 850;
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // setLoginDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    setTabSelected(props.tab);
  }, [props.tab]);

  return (
    <View style={[styles.container]}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        py={0.5}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontFamily: "Roboto",
              fontSize: "18px",
            }}
          >
            Analyst Portal
          </Text>
        </View>
        {/* <View style={{ flexDirection: "row", alignItems: "center" }}> */}
        {/* <TouchableOpacity
            style={{ zIndex: 2 }}
            onPress={() => setLoginDropdown(!loginDropdown)}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <FaUser size={isMobile ? 14 : 25} />
              <Text
                style={{
                  marginStart: 10,
                  fontWeight: "600",
                  fontSize: isMobile ? 10 : 14,
                }}
              >
                {analystName}
              </Text>
            </View>
          </TouchableOpacity>
          {loginDropdown && (
            <div
              ref={ref}
              style={{ position: "absolute", right: 0, top: "100%" }}
            >
              <SimpleButton
                onPress={() => props.LogoutUser(queryClient)}
                customStyle={{
                  backgroundColor: "grey",
                  paddingHorizontal: 10,
                }}
                label={"Logout"}
              />
            </div>
          )}
        </View> */}
        <div>
          <Button
            onClick={handleMenu}
            sx={{ gap: 0, px: 0.5 }}
            startIcon={
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                sx={{ p: 0 }}
              >
                <AccountCircle />
              </IconButton>
            }
            variant="text"
          >
            {analystName}
          </Button>

          <Menu
            slotProps={{
              root: {
                sx: {
                  backgroundColor: "#12121350",
                },
              },
            }}
            id="menu-appbar"
            anchorEl={anchorEl}
            // anchorOrigin={{
            //   vertical: "bottom",
            //   horizontal: "left",
            // }}
            keepMounted
            // transformOrigin={{
            //   vertical: "bottom",
            //   horizontal: "left",
            // }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                props.LogoutUser(queryClient);
              }}
              sx={{ p: 0 }}
            >
              <Button endIcon={<LogoutSharp />} sx={{ fontSize: "14px" }}>
                Logout
              </Button>
            </MenuItem>
          </Menu>
        </div>
      </Stack>

      <Stack
        sx={{
          gap: 4,
          width: "100%",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <TouchableOpacity
          onPress={() => {
            setTabSelected("home");
          }}
        >
          <Link
            to="/home"
            style={{
              textDecoration: "none",
              fontSize: "0.9em",
              fontWeight: 600,
              color:
                tabSelected === "home"
                  ? "rgba(178, 83, 0, 1)"
                  : "rgba(84, 93, 105, 1)",
              paddingBottom: "6px",
              borderBottom: "0.2em solid",
              borderBottomColor:
                tabSelected === "home"
                  ? "rgba(178, 83, 0, 1)"
                  : "rgba(218, 222, 227, 1)",
            }}
          >
            Home
          </Link>
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() => {
            setTabSelected("management");
          }}
        >
          {isAdmin && (
            <Link
              to="/management"
              style={{
                textDecoration: "none",
                fontSize: "0.9em",
                fontWeight: 600,
                color:
                  tabSelected === "management"
                    ? "rgba(178, 83, 0, 1)"
                    : "rgba(84, 93, 105, 1)",
                paddingBottom: "6px",
                borderBottom: "0.2em solid",
                borderBottomColor:
                  tabSelected === "management"
                    ? "rgba(178, 83, 0, 1)"
                    : "rgba(218, 222, 227, 1)",
              }}
            >
              Match Management
            </Link>
          )}
        </TouchableOpacity>
      </Stack>
    </View>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: 60,
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0px 0px 15px #d1d1d1",
    // top: 0,
    paddingHorizontal: 20,
    zIndex: 100,
    backgroundColor: "#fff",
    // position: "absolute",
  },
  loadingText: {},
};

const mapDispatchToProps = (dispatch) => {
  return {
    LogoutUser: () => {
      dispatch(LogoutUser());
    },
  };
};

export default connect("", mapDispatchToProps)(Header);
